import React, { CSSProperties, useContext } from 'react'
import { Cell } from 'react-sticky-table'
import styled from 'styled-components'
import { Box } from '../box'
import { settings, ThemeColors } from '../theme/colors'
import { tableBorderStyle, cellHeightValues } from './const'
import { tableContext } from './TableContext'

interface Props {
  align?: 'left' | 'center' | 'right'
  alignItems?: string
  bg?: ThemeColors
  children: React.ReactNode
  component?: 'th' | 'td'
  flex?: boolean
  isHeadCell?: boolean
  isPlaceholder?: boolean
  noPadding?: boolean
  sticky?: boolean
  stickyBgColor?: string
  stickyRightBorder?: boolean
  style?: CSSProperties
  width?: number | string
}

const StyledCell = styled(Cell)`
  &.sticky-table-cell {
    background: ${({ bg }) => (bg ? settings.colors[bg as ThemeColors] : 'auto')};
    padding: ${props => (props.noPadding ? '0' : '0 16px')};
    height: ${props => `${props.height}px`};
    width: ${({ width }) =>
      width ? (typeof width === 'string' ? `${width};` : `${width}px;`) : 'auto;'};
    z-index: ${({ stickyParams }) => (stickyParams ? 1 : 'auto')};
    position: relative;
    border-right: ${({ noRightBorder }) =>
      noRightBorder ? 'none' : '1px solid rgba(30, 44, 71, 0.08)'};
    white-space: ${({ isTableLayoutFixed }) => (isTableLayoutFixed ? 'normal' : 'nowrap')};
    box-shadow: ${props =>
      props.stickyRightBorder ? '4px 0px 0px rgba(142, 168, 190, 0.12)' : 'none'};

    &:last-child {
      border-right: none;
    }

    vertical-align: middle;
  }
  text-align: ${props => props.align || 'left'};

  span {
    border: none !important;
    /* fix for wrong placed styles from react-sticky-table */
  }

  .sc-AxirZ {
    border: none !important;
    /* fix for wrong placed styles from react-sticky-table */
  }
`
export function TableCell({
  children,
  component,
  align = 'left',
  sticky = false,
  stickyRightBorder = false,
  stickyBgColor = '#FFFFFF',
  style,
  isPlaceholder,
  width,
  bg,
  isHeadCell,
  ...others
}: Props) {
  const {
    cellHeight,
    headCellHeight,
    isTableLayoutFixed,
    isNoCellRightBorders,
    sticky: stickyParams,
  } = useContext(tableContext)
  const borderBottom = sticky ? tableBorderStyle : undefined

  return (
    <StyledCell
      stickyParams={stickyParams}
      role={isHeadCell ? 'columnheader' : 'cell'}
      data-table-node='td'
      style={{ backgroundColor: sticky ? stickyBgColor : 'none', borderBottom, ...style }}
      align={align}
      stickyRightBorder={stickyRightBorder}
      width={width}
      bg={bg}
      height={cellHeightValues[isHeadCell ? headCellHeight : cellHeight]}
      isTableLayoutFixed={isTableLayoutFixed}
      noRightBorder={isNoCellRightBorders}
      {...others}
    >
      {isPlaceholder ? (
        <Box h={cellHeight === 'condensed' ? 7 : 9} bg='neutral-light-16' />
      ) : (
        children
      )}
    </StyledCell>
  )
}
